import { SearchFeatureConfigSchema, type SearchFeatureConfig } from '@school-journey/shared-types'

import type { ScreenFeatureEntry } from './entry'

/**
 * Global `search`: feed search in the mobile app (SCH-3189).
 *
 * absentIsEmpty: no row carries the block until a school's admin first saves
 * it; the fleet-default row must never carry it (see the schema's docblock).
 *
 * Fallback: search off. Mobile shows search only when `enabled === true`
 * (`isSearchVisibleForMember`, shared-types `global-features.ts`).
 * `visibleForRoles` is required by the schema and inert for this key; `[]` is
 * the server's backfill for a feature with no canonical default
 * (`apps/backend/src/services/config/global-feature-defaults.ts`).
 *
 * toWire: every save writes the FULL block (`enabled`, `betaOnly`,
 * `visibleForRoles`), as `classGrades` does, so the stored row means what it
 * says without relying on the read's backfill.
 */
export const search: ScreenFeatureEntry<'global', 'search', SearchFeatureConfig> = {
  resource: 'global',
  wireName: 'search',
  schema: SearchFeatureConfigSchema,
  writeMode: 'sparse',
  absentIsEmpty: true,
  fallback: {
    enabled: false,
    betaOnly: false,
    visibleForRoles: []
  },
  toWire: (change, current) => {
    const next = { ...current, ...change }
    return {
      enabled: next.enabled,
      betaOnly: next.betaOnly,
      visibleForRoles: next.visibleForRoles
    }
  }
}
